import consumer from "./bigdata_consumer"

// Only wire this up on the database page (avoid a stray cross-app socket elsewhere).
function onDatabasePage() {
  return !!document.querySelector("#accordionDatabases")
}

// Completion events carry bigdata-rendered HTML (with bigdata routes). We do NOT
// inject that HTML; instead we reload so this app re-renders the tabs with its
// own routes. Debounced so rapid events don't cause multiple reloads.
let reloadTimer = null
function scheduleReload() {
  if (reloadTimer) return
  reloadTimer = setTimeout(function () {
    window.location.reload()
  }, 1200)
}

consumer.subscriptions.create("FolderStatusChannel", {
  received(data) {
    if (!onDatabasePage()) return

    const { folder_id, verification_status, remove_dnc_status, merge_status } = data

    // Live verify progress percentage
    if (data.verify_progress) {
      const statusEl = document.querySelector(`.verifying-status-${folder_id}`)
      if (statusEl) statusEl.textContent = `${data.verify_progress.percentage}%`
      return
    }

    // Verification status badge
    const verificationBadge = document.querySelector(`.index-verification-status-${folder_id}`)
    if (verificationBadge && verification_status !== undefined && verification_status !== null) {
      const klass = verification_status === "Verified" ? "badge-dnc" : "badge-red"
      verificationBadge.textContent = verification_status
      verificationBadge.className = `status-badge mb-1 p-1 text-center index-verification-status-${folder_id} ${klass}`
    }

    // DNC status badge
    const dncBadge = document.querySelector(`.index-dnc-status-${folder_id}`)
    if (dncBadge && remove_dnc_status !== undefined && remove_dnc_status !== null) {
      const label = getDncStatusLabel(remove_dnc_status)
      const klass = label === "DNC Filtered" ? "badge-dnc" : "badge-red"
      dncBadge.textContent = label
      dncBadge.className = `status-badge mb-0 p-1 text-center index-dnc-status-${folder_id} ${klass}`
    }

    // Merge status text
    const mergeBadge = document.querySelector(`.merging-status-${folder_id}`)
    if (mergeBadge && merge_status !== undefined && merge_status !== null) {
      mergeBadge.textContent = merge_status
    }

    // A phase finished (bigdata sent rendered tab HTML) -> reload to get this
    // app's freshly-rendered tabs/buttons with correct routes.
    if (data.merge_tab_html || data.verify_tab_html || data.remove_tab_html || data.upload_action_btn_html) {
      scheduleReload()
    }
  }
})

function getDncStatusLabel(status) {
  switch (status) {
    case "Not Removed":
      return "DNC Pending"
    case "Removing":
      return "DNC Filtering"
    case "Removed":
      return "DNC Filtered"
    case "Partially Removed":
      return "Partially DNC Filtered"
    default:
      return status
  }
}
